export default {
  tabs: {
    detailed: {
      notes:
        'Tab title for the detailed property comparison in the selection details pane',
      message: 'Detailed',
    },
    bom: {
      notes: 'Tab title for the bill of material in the selection details pane',
      message: 'BOM',
    },
    actions: {
      notes: 'Tab title for the planned actions in the selection details pane',
      message: 'Actions',
    },
  },
  viewingAll: {
    detailed: {
      notes:
        'Shown above the detailed tab in the selection details pane when no panels are selected',
      message: 'All detailed',
    },
    bom: {
      notes:
        'Shown above the BOM tab in the selection details pane when no panels are selected',
      message: 'All BOM',
    },
    activityBom: {
      notes:
        'Shown above the BOM tab of a screen activity when no panels are selected; the list only holds the components the planned replacements need',
      message: 'Components required for activity',
    },
    actions: {
      notes:
        'Shown above the actions tab in the selection details pane when no panels are selected',
      message: 'All actions',
    },
  },
  overview: {
    total: {
      notes:
        'Label of the sum row at the bottom of the overview tables shown when no panels are selected',
      message: 'Total',
    },
  },
  summary: {
    selected: {
      notes:
        'Header of the selection action bar. {{ranges}} is a comma-separated list of selected panel positions, e.g. "A1, B2–C2, Row 3"',
      message: 'Selected: {{ranges}}',
    },
    row: {
      notes:
        'A fully selected deck row in the selection summary. {{row}} is the row number',
      message: 'Row {{row}}',
    },
    rows: {
      notes:
        'A range of fully selected deck rows in the selection summary. {{start}} and {{end}} are row numbers',
      message: 'Rows {{start}}–{{end}}',
    },
    column: {
      notes:
        'A fully selected deck column in the selection summary. {{column}} is the column letter',
      message: 'Column {{column}}',
    },
    columns: {
      notes:
        'A range of fully selected deck columns in the selection summary. {{start}} and {{end}} are column letters',
      message: 'Columns {{start}}–{{end}}',
    },
    more: {
      notes:
        'Shown at the end of the selection summary when there are more ranges than can be displayed. {{count}} is the number of hidden ranges',
      message: '+{{count}} more',
    },
  },
  propertyColumn: {
    notes: 'Column header for the property name in the selection details table',
    message: 'Property',
  },
  valueColumn: {
    notes:
      'Column header for the property value in the selection details table',
    message: 'Value',
  },
  stateColumn: {
    notes: 'Column header for the change state in the selection details table',
    message: 'State',
  },
  editableOnly: {
    notes:
      'Toggle button above the detailed selection table that hides the properties which cannot be edited',
    message: 'Editable only',
  },
  rotation: {
    notes:
      'Property row in the selection details table showing how the panel is mounted',
    message: 'Rotation',
    values: {
      none: {
        notes: 'Panel rotation value: mounted in the default orientation',
        message: 'None',
      },
      deg_180: {
        notes: 'Panel rotation value: mounted turned 180 degrees',
        message: '180°',
      },
    },
  },
  editActions: {
    selectMedia: {
      notes:
        'Option in the value edit dropdown that opens the screening media selection dialog',
      message: 'Select screening media...',
    },
    revert: {
      notes:
        'Option in the value edit dropdown that reverts the screening media of the selected panels',
      message: 'Revert',
    },
  },
  changed: {
    notes:
      'Shown in the state column when a property differs from the compared panels',
    message: 'Changed',
  },
  unchanged: {
    notes:
      'Shown in the state column when a property matches the compared panels',
    message: 'Unchanged',
  },
};
